module.exports = __webpack_public_path__ + "img/profile-man-3-min.adc365d6.jpg";